import { useHistory } from 'components/ReactRouterProvider/context'
import { useCallback, useMemo } from 'react'
import { encodeExploreState, ExploreTableState } from './filter-params'

export default function useSyncStateFromURL() {
  const history = useHistory()

  const currentState = useMemo(() => new URLSearchParams(history.location.search), [history.location.search])
  const sync = useCallback(
    (state: ExploreTableState) => {
      const newParams = encodeExploreState(state, currentState)
      history.replace({
        search: newParams.toString(),
      })
    },
    [currentState, history],
  )

  return [currentState, sync] as const
}
